export default __webpack_public_path__ + "static/media/InstoreX3-02.f208c5c1.png";